import React, { useState } from "react";
import styles from "./Home.module.css";
import Header from "../../components/header/Header";
import PageHeading from "../../components/PageHeading/PageHeading";
import "./addCustomer.css";

import CustomerDetailsForm from "./CustomerDetailsForm";
import TradeReferenceForm from "./TradeReferenceForm";
import { useSearchParams } from "react-router-dom";

const AddEditCustomrer: React.FC = () => {
  const [activeTab, setActiveTab] = useState("customerDetails");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const operation = searchParams.get("operation");
  return (
    <div className={styles.container}>
      <Header />
      <div className={`m-4 login-registration-container `}>
        <PageHeading title="Add Customer" backTo="/?tab=customers" />
        <div className="customer-details-tab my-2">
          <div
            className={`tab-item ${
              activeTab === "customerDetails" ? "active" : ""
            }`}
            onClick={() => setActiveTab("customerDetails")}
          >
            Customer Details
          </div>
          {id && (
            <div
              className={`tab-item ${
                activeTab === "tradeReference" ? "active" : ""
              }`}
              onClick={() => setActiveTab("tradeReference")}
            >
              Trade Reference
            </div>
          )}
        </div>
        {activeTab === "customerDetails" && <CustomerDetailsForm />}
        {activeTab === "tradeReference" && <TradeReferenceForm />}
      </div>
    </div>
  );
};

export default AddEditCustomrer;
